'use client'

import { motion } from 'framer-motion'
import { Phone, ShoppingBag } from 'lucide-react'

export default function PromoHero() {
  return (
    <section
      className="
        relative
        w-full
        overflow-hidden rounded-2xl shadow-2xl
        /* Altura XS más compacta; en sm+ usa la fluida anterior */
        h-[200px] sm:h-[clamp(160px,24vw,300px)]
        mb-6
      "
    >
      {/* Fondo: XS = vertical (azul→amarillo), SM+ = radial original */}
      <div
        className="
          absolute inset-0
          bg-[linear-gradient(180deg,#0b7080_0%,#0e8fa0_45%,#f59e0b_100%)]
          sm:bg-[radial-gradient(60%_120%_at_25%_50%,#063d4a_0%,#0b7080_45%,#0e8fa0_65%,#f59e0b_100%)]
        "
      />
      <svg
        className="absolute right-2 top-2 h-20 w-20 text-amber-400 sm:-right-6 sm:-top-6 sm:h-36 sm:w-36"
        viewBox="0 0 200 200"
        fill="currentColor"
      >
        <path d="M51.2,-67.7C63.9,-57.7,69.6,-38.9,74.6,-20.4C79.7,-1.9,84,15.3,78.6,29.6C73.2,43.8,58,55.2,42,64.6C26,74,9.3,81.5,-5.7,80.1C-20.7,78.7,-34.1,68.3,-47.3,57.2C-60.6,46.1,-73.8,34.3,-79.6,19.2C-85.4,4.1,-83.7,-14.3,-76.6,-30.1C-69.6,-45.9,-57.1,-58.9,-42.5,-69.8C-28,-80.8,-14,-89.6,2.1,-92.4C18.2,-95.3,36.4,-92,51.2,-67.7Z" />
      </svg>

      {/* Contenido centrado vertical; grid 1 col en XS, 2 cols en md+ */}
      <div className="relative h-full flex items-center">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 md:grid-cols-2 gap-3 px-3 sm:px-6">
          {/* TEXTOS — XS más chico */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="text-white self-center"
          >
            <div className="mb-1 inline-flex items-center gap-2 rounded-full border-2 border-white/70 px-2 py-[2px] text-[10px] sm:text-xs font-semibold">
              <span>SAVE</span>
              <span>50%</span>
            </div>

            <div className="text-amber-300 [font-family:'Pacifico',cursive] text-xl sm:text-3xl">
              Oferta Limitada
            </div>
            <div className="-mt-1 text-[30px] sm:text-[54px] md:text-[62px] leading-[0.95] font-black tracking-wide [font-family:'Bebas Neue',sans-serif]">
              DESAYUNO
            </div>
            <div className="mb-1 text-base sm:text-2xl font-semibold text-amber-300 [font-family:'Pacifico',cursive]">
              Personalizado
            </div>

            <p className="mb-2 max-w-md text-[11px] sm:text-sm text-white/90">
              Desayunos artesanales y combos dulces. Hechos con amor y los mejores ingredientes.
            </p>

            <div className="flex flex-wrap items-center gap-2">
              <a
                href="#order"
                className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 text-[11px] sm:text-sm font-semibold text-black shadow transition hover:translate-y-[1px] hover:bg-amber-300"
              >
                <ShoppingBag className="h-4 w-4" /> Pedilo Ahora
              </a>
              <a
                href="tel:+5491164615467"
                className="inline-flex items-center gap-2 rounded-full border border-white/60 px-3 py-1 text-[11px] sm:text-sm text-white/90 backdrop-blur-sm transition hover:border-white hover:text-white"
              >
                <Phone className="h-4 w-4" /> +54 9 11 64615467
              </a>
            </div>
          </motion.div>

          {/* IMAGEN */}
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.45, delay: 0.05 }}
            className="
              relative justify-self-end self-center
              hidden sm:flex items-center
              h-[calc(100%-50px)]
              px-[25px]
              z-10
            "
          >
            <img
              src="/banner/bandeja.png"
              alt="Desayuno artesanal"
              loading="lazy"
              className="h-full w-auto object-contain select-none pointer-events-none [filter:drop-shadow(0_3px_0_rgba(0,0,0,.14))_drop-shadow(0_28px_48px_rgba(0,0,0,.42))]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
